import { UserList } from '../../modules/user-management/user-list/components/UserList/UserList';

export const UserListPage = (): JSX.Element => <UserList />;
